// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25aET","name":"styles_name__1Lucq","phone":"styles_phone__1y3gm"};